import React from "react";
import { SRMIcon as SrmTag } from "@picklebet/ui";
import { SGMIcon as SgmTag } from "@picklebet/ui";

import { useIsParlayLocale } from "@/hooks/useMultiSlug";
import * as styles from "@/features/betslip/components/parts/SemBadge.module.scss";

type SemBadgeProps = {
  variant: "srm" | "sgm";
};

export const SemBadge = ({ variant }: SemBadgeProps) => {
  const isParlayLocale = useIsParlayLocale();
  const Tag = variant === "srm" ? SrmTag : SgmTag;
  return (
    <span className={styles.badge} data-testid={`sem-badge-${variant}`}>
      <Tag isParlayLocale={isParlayLocale} />
    </span>
  );
};
